import {Button, ModalTitle} from "@kaltura/ds-react-components";
import {baseUrl, getDataFromKms, translate} from "@mediaspace/shared/utils";
import {useRef, useState} from "react";
import {StyledModalContent, StyledModalActions} from "./StyledComponents";
import ImportChannelList from "./import-channel-list/ImportChannelList";
import Message from "./message/Message";

export type ImportChannelModalContentProps = {
    onModalClose: () => void;
    channels: Record<string, string>[];
    url: string;
    channelId: number;
    errorMessage: string;
    onShowNotification: (message, severity) => void;
}

/**
 * Channel Import Channel action Modal content
 */
const ImportChannelModalContent = (props: ImportChannelModalContentProps) => {

    const {onModalClose, url, channels, channelId, errorMessage, onShowNotification} = props;

    const [selectedChannel, setSelectedChannel] = useState<string | undefined>();
    const [processing, setProcessing] = useState<boolean>(false);

    const status = useRef("");

    const onChannelSelect = (id) => {
        setSelectedChannel(id)
    }

    const importStatus = () => {
        getDataFromKms(
            `${baseUrl}/importchannel/index/import-status`,
            { token: `${selectedChannel}-${channelId}` },
            (statusResult) => {
                status.current = statusResult.status;
            },
            false,
            onError
        );
    }

    const onImportStart = () => {
        status.current = "started"
        const interval = setInterval(() => {
            if (status.current === "failed") {
                clearInterval(interval);
                onError();
            } else if (status.current === "done") {
                clearInterval(interval);
                onImportDone();
            } else {
                importStatus();
            }
        }, 5000);
        setTimeout(() => {
            onModalClose()
        }, 2000)
    }

    const onImportDone = () => {
        onShowNotification(
            translate("Importing completed successfully, Please refresh the page for updated list."),
            "success"
        )
    }

    const onError = () => {
        onModalClose();
        onShowNotification(translate("Error Importing"), "error");
    }

    const onImportRequest = () => {
        setProcessing(true);
        getDataFromKms(
            `${baseUrl}${url}`,
            {
                sourceId: selectedChannel,
                targetId: channelId
            },
            onImportStart,
            false,
            onError
        );
    }

    const onClose = () => {
        onModalClose();
    }

    return (
        <>
            {(!errorMessage && !processing) &&
                <ModalTitle>
                    {translate("Select the channel you want to import")}
                </ModalTitle>
            }
            <StyledModalContent>
                {errorMessage && <Message text={errorMessage} />}
                {(!errorMessage && processing) &&
                    <Message
                        showTitle={true}
                        text={translate("The import process has started, a notification will appear once completed.")}
                    />
                }
                {(!errorMessage && !processing) &&
                    <ImportChannelList
                        channels={channels}
                        selectedChannel={selectedChannel}
                        onChannelSelect={onChannelSelect}
                    />
                }
            </StyledModalContent>
            <StyledModalActions>
                <Button
                    aria-label={translate("Cancel")}
                    onClick={onClose}
                    key={"cancel"}
                    variant={"borderless"}
                >
                    {translate("Cancel")}
                </Button>
                <Button
                    aria-label={translate("Import")}
                    key={"create"}
                    onClick={onImportRequest}
                    disabled={!selectedChannel}
                    loading={processing}
                >
                    {translate("Import")}
                </Button>
            </StyledModalActions>
        </>
    )
};

export default ImportChannelModalContent;
